import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import React from 'react';

import { IMPORT_STEPS } from '../../../../constants/import.constants';
import { getActionMenuItems } from '../../../../utils/common.utils';

const SelectCell = ({ row, column: { accessor: key } }) => {
  const value = row[key];

  const { isLoading, importStep } = row;

  const menuItems = getActionMenuItems({ type: row?.Type });
  const disabled =
    !(menuItems?.length > 1) || isLoading || importStep === IMPORT_STEPS.UPLOAD_COMPLETED;

  const handleSelect = (e) => {
    e.target.value && row?.handleEditRow({ id: row?.id, key, value: e.target.value });
  };

  return (
    <>
      <Select
        size="small"
        fullWidth
        asteriskPosition="before"
        value={value}
        disabled={disabled}
        onChange={handleSelect}
      >
        {menuItems?.map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default SelectCell;
